import { defineComponent, createElementBlock, openBlock, normalizeClass, createElementVNode } from "vue";
import { _ as _export_sfc } from "./chunks/_plugin-vue_export-helper.js";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "p-close-btn",
  props: {
    variant: {
      type: String,
      default: "transparent"
    }
  },
  setup(__props) {
    const variantClasses = {
      transparent: ["bg-transparent", "hover:bg-p-gray-20"],
      gray: ["bg-p-gray-10", "hover:bg-p-gray-20"],
      dark: ["bg-transparent"]
    };
    const iconClass = {
      transparent: "x-black-icon",
      gray: "x-black-icon",
      dark: "x-white-icon"
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("button", {
        type: "button",
        class: normalizeClass(["inline-flex h-8 w-8 cursor-pointer items-center justify-center rounded focus:outline-none disabled:cursor-default disabled:opacity-30 disabled:hover:bg-white", variantClasses[__props.variant]])
      }, [
        createElementVNode("i", {
          class: normalizeClass(["block h-3 w-3 bg-center bg-no-repeat", iconClass[__props.variant]])
        }, null, 2)
      ], 2);
    };
  }
});
const PCloseBtn = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-f61993bb"]]);
export {
  PCloseBtn as default
};
